import React from 'react';

import DateLabel from '../../../Components/DateLabel';
import DateRangeLabel from '../../../Components/DateRangeLabel';

import CustomerChannels from '../../../StaticData/CustomerChannels';
import TravelerHelper from '../../../Helper/Traveler';
export default class FITDetail extends React.Component {
	render() {
		const { fit } = this.props;
		const displayOrDash = value => {
			if (value == null) return '-';
			const text = String(value).trim();
			return text === '' ? '-' : text;
		};

		return (
			<div className="row">
				ลูกค้า: <strong>{TravelerHelper.getFullName(fit.traveler)}</strong> <br />
				เบอร์โทร: <strong>{displayOrDash(fit.traveler.telephone)}</strong> <br />
				email: <strong>{displayOrDash(fit.traveler.email)}</strong> <br />
				วันที่:{' '}
				<strong>
					<DateRangeLabel startDate={fit.startDate} endDate={fit.endDate} />
				</strong>
				<br />
				วันทำจอง:{' '}
				<strong>
					<DateLabel date={fit.created_at} />
				</strong>
				<hr />
				กำหนดชำระเงิน:{' '}
				<strong>
					<DateLabel date={fit.dueDatePayment} />
				</strong>
			</div>
		);
	}
}
